import type { Cell, Piece } from "./types";
import { state } from "./state";
import { slotsEl, highlightEl, stageEl } from "../dom";

/** Occupancy grid: occ[r][c] holds the id of the piece covering that cell, or
 *  null. Rebuilt to the current stage's dimensions by rebuildBoard(). */
let occ: (number | null)[][] = [];

/** Size the occupancy grid + slot/highlight DOM to the current stage. */
export function rebuildBoard(): void {
  const { cols, rows } = state;
  occ = Array.from({ length: rows }, () => Array<number | null>(cols).fill(null));
  stageEl.style.setProperty("--gcols", String(cols));
  stageEl.style.setProperty("--grows", String(rows));
  slotsEl.innerHTML = "";
  highlightEl.innerHTML = "";
  for (let i = 0; i < rows * cols; i++) {
    const s = document.createElement("div");
    s.className = "slot";
    slotsEl.appendChild(s);
    const h = document.createElement("div");
    h.className = "hcell";
    highlightEl.appendChild(h);
  }
}

/** Can the shape `cells` sit at grid offset (gr,gc) without leaving the grid
 *  or overlapping a piece other than `ignoreId`? */
export function canPlace(cells: Cell[], gr: number, gc: number, ignoreId: number | null): boolean {
  const { cols, rows } = state;
  for (const [r, c] of cells) {
    const R = gr + r, C = gc + c;
    if (R < 0 || C < 0 || R >= rows || C >= cols) return false;
    const o = occ[R][C];
    if (o !== null && o !== ignoreId) return false;
  }
  return true;
}

export function writeOcc(p: Piece): void {
  if (!p.pos) return;
  for (const [r, c] of p.cells) occ[p.pos.r + r][p.pos.c + c] = p.id;
}

export function clearOcc(p: Piece): void {
  const { cols, rows } = state;
  for (let r = 0; r < rows; r++) for (let c = 0; c < cols; c++) if (occ[r][c] === p.id) occ[r][c] = null;
}

export function spaceUsed(): number {
  const { cols, rows } = state;
  let n = 0;
  for (let r = 0; r < rows; r++) for (let c = 0; c < cols; c++) if (occ[r][c] !== null) n++;
  return n;
}

export function clearHighlight(): void {
  for (const h of Array.from(highlightEl.children)) h.classList.remove("valid", "invalid");
}
